import React from "react";

/** Quadradinho com o ícone (ou a logo) do módulo, na cor dele. */
export default function IconeModulo({ modulo, tamanho = "w-8 h-8", icone = "w-4 h-4", forma = "rounded-lg" }) {
  return (
    <span className={`${tamanho} ${forma} flex items-center justify-center shrink-0 ${modulo.chip || "bg-primary/10 text-primary"}`}>
      {modulo.logo
        ? <img src={modulo.logo} alt="" className={`${icone} object-contain`} onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
        : <modulo.Icon className={icone} />}
    </span>
  );
}
